import React, { useEffect, useState } from "react";
import DynamicTable from "../../../layout/DynamicTable/DynamicTable";
import { action, controller } from "../../../api/api";
import Header from "./Header";
import { formatDecimal } from "../../../hooks/Method";
import { IconButton, Tooltip } from "@mui/material";
import { RemoveRedEyeRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const ProductMovement = () => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [isFastMoving, setIsFastMoving] = useState(true);
  const [endpoint, setEndpoint] = useState(
    controller.Report + action.FastMovingProds
  );

  const handleView = (val) => {
    navigate(`/product_form/${val.prodId}`);
  };

  const handleSort = () => {
    if (!isFastMoving) {
      setEndpoint(controller.Report + action.FastMovingProds);
      setIsFastMoving(true);
    } else {
      setEndpoint(controller.Report + action.SlowMovingProds);
      setIsFastMoving(false);
    }
  };

  useEffect(() => {
    setTblData([
      ...reports.map((r) => ({
        ...r,
        product: (
          <div className="flex flex-col gap-1">
            <span className="font-medium text-[14px]">{r.label}</span>
            <span className="text-[12px]">{r.subtitle}</span>
          </div>
        ),
        soldQty: <span className="font-medium">{r.soldQty}</span>,
        totalRevenue: (
          <span className="font-medium">
            $ {formatDecimal(r.totalRevenue, true)}
          </span>
        ),
      })),
    ]);

    return () => {};
  }, [reports]);

  const ActionComp = (val) => (
    <div className="border !border-gray-100 flex gap-2 p-[3px] shadow-sm rounded-[12px] w-fit">
      <Tooltip title="View Customer Profile">
        <IconButton
          onClick={() => handleView(val)}
          size="small"
          color="primary"
        >
          <RemoveRedEyeRounded className="!text-[18px]" />
        </IconButton>
      </Tooltip>
    </div>
  );

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setReports}
        enableDateRange={true}
        enableExport={true}
        exportEndpoint={controller.Report + action.ExportProductMovement}
        endpointKey={endpoint}
        ActionComp={ActionComp}
        HeaderComp={() => <Header />}
        headers={[
          { id: "actions", label: "Actions" },
          { id: "product", label: "Product" },
          {
            id: "soldQty",
            label: (
              <div className="flex flex-col gap-0 leading-5">
                <span className="text-[12px] pl-[10px]">Sold Quantity</span>

                <span
                  onClick={handleSort}
                  className="text-[14px] hover:underline cursor-pointer"
                >
                  {isFastMoving
                    ? "⚡Fast moving products"
                    : "⏳ Slow moving products"}
                </span>
              </div>
            ),
          },
          { id: "totalRevenue", label: "Total Revenue" },
          { id: "lastSoldDate", label: "Last sold date" },
        ]}
      />
    </>
  );
};

export default ProductMovement;
